import React from 'react';
import ImageSvg from '../images/ImageSvg.react';

class FlashMessage extends React.Component {
	static defaultProps = {
	  options: { style: { } },
	  id: false,
	  key: false,
	  type: false,
	  message: '',
	};

	render() {
	  const containerClass = 'flash js-hide';
	  let innerClass = 'flash-inner';
	  let icon = (<div />);
	  if (this.props.type) {
	    innerClass += ` ${this.props.type}`;
	    if (this.props.type == 'error') {
	      icon = (<ImageSvg svg="icon-warning" iconClass="icon--full icon--warning" />);
	    } else if (this.props.type == 'success') {
	      icon = (<ImageSvg svg="icon-check-2" iconClass="icon--full icon--check-2" />);
	    } else if (this.props.type == 'notice') {
	      icon = (<ImageSvg svg="icon-warning-2" iconClass="icon--full icon--warning-2" />);
	    }
	  }

	  return (
	    <div className={containerClass} style={this.props.options.style}>
	      <div className="message">
	        <div className={innerClass}>
	          <div className="flash-icon">
	            {icon}
	          </div>
	          <div className="flash-content">
	            {this.props.message}
	          </div>
	        </div>
	        <a href="#" className="flash-close" data-hide=".js-hide">x</a>
	      </div>
	    </div>
	  );
	}
}

module.exports = FlashMessage;
